import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-muted-foreground" data-testid="protected-loading">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (adminOnly && !["admin", "editor"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
